<template>
  <div class="card" :class="{ 'last-game': isLastGame }">
    <span v-if="isLastGame" class="ribbon3">最近游戏</span>
    <div class="card__image-holder">
      <img class="card__image" :src="game.cover" alt="wave"/>
    </div>
    <div class="card-title">
      <span class="toggle-info btn">
        <span class="left"></span>
        <span class="right"></span>
      </span>
      <div 
        v-if="!isLastGame"
        @click.stop="handleFavorite" 
        id="heart"
        :class="favoriteClass"
      >
        <div class="heart-flip"></div>
      </div>
      <h2>
        {{ game.name }}
        <small>{{ game.desc }}</small>
      </h2>
    </div>
    <div class="card-flap flap1">
      <div class="card-description">
        {{ game.more }}
      </div>
      <div class="card-flap flap2">
        <div class="card-actions">
          <span @click.prevent="handleGameClick" class="btn">{{ buttonText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GameCard",
  props: {
    game: {
      type: Object,
      required: true
    },
    isLastGame: {
      type: Boolean,
      default: false
    },
    isFavorite: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: '开始游戏'
    }
  },
  computed: {
    favoriteClass() {
      return this.isFavorite ? 'active heart' : 'heart';
    }
  },
  methods: {
    handleGameClick() {
      this.$emit('game-click', this.game);
    },
    handleFavorite() {
      this.$emit('favorite-toggle', this.game);
    }
  }
}
</script>

<style>
/* Card styles are imported globally to work with jQuery interactions */
@import '../css/cards.css';
</style>

<style scoped>
.ribbon3 {
  display: inline-block;
  position: absolute;
  color: #fff;
  font-size: 20px;
  width: 150px;
  height: 50px;
  line-height: 50px;
  padding-left: 15px;
  background: linear-gradient(100deg, #24A4EA, #379DEB 25%, #B76BF0);
  left: -8px;
  top: 20px;
  z-index: 1;
}

.ribbon3:before, .ribbon3:after {
  content: "";
  position: absolute;
}

.ribbon3:before {
  height: 0;
  width: 0;
  border-bottom: 8px solid #24A4EA;
  border-left: 8px solid transparent;
  top: -8px;
  left: 0;
}

.ribbon3:after {
  height: 0;
  width: 0;
  border-top: 25px solid transparent;
  border-bottom: 25px solid transparent;
  border-left: 15px solid #B76BF0;
  right: -15px;
}
</style>